import { clearStoredSessionToken, getStoredSessionToken } from './auth/session';

function resolveApiBaseUrl() {
  const rawUrl = (process.env.REACT_APP_BACKEND_URL || '').trim();
  if (!rawUrl) return '';
  const normalizedUrl = rawUrl.replace(/\/+$/, '');

  try {
    const parsed = new URL(normalizedUrl);
    if (typeof window !== 'undefined' && parsed.host !== window.location.host) {
      return '';
    }
    return normalizedUrl;
  } catch {
    return '';
  }
}

const API_URL = resolveApiBaseUrl();
export const DEFAULT_MAINTENANCE_MESSAGE = 'Réservations temporairement indisponibles pendant la mise à jour du nouveau site.';

// ── Hero background images ──
// Restauration partielle 2026-05-27 (boss) : sur portable + accueil, retour
// à l'image Unsplash "laptop sombre minimaliste" préférée. Sur les desktops,
// on conserve l'image locale /hero-desktop.jpg (composants/carte graphique).
const HERO_IMG_LAPTOP = 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=1600&q=70&auto=format&fit=crop';
const HERO_IMG_DESKTOP = '/hero-desktop.jpg';
const HERO_IMG_WORKSHOP = 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=1600&q=70&auto=format&fit=crop';

export const HERO_IMAGES = {
  laptop: HERO_IMG_LAPTOP,
  desktop: HERO_IMG_DESKTOP,
  workshop: HERO_IMG_WORKSHOP,
};

// Retourne l'URL image Hero adaptée au produit (laptop vs desktop/tour)
export function getHeroImageForProduct(product) {
  if (!product) return HERO_IMG_WORKSHOP;
  const modelStr = `${product.specs?.model || ''} ${product.specs?.display_name || ''} ${product.name || ''}`;
  const isDesktop = /\b(SFF|DT|Desktop|Tower|MT|Mini Tower|MicroTower|ProDesk|EliteDesk|OptiPlex|ThinkCentre|Aurora|Inspiron Desktop)\b/i.test(modelStr);
  const isLaptop = /portable|laptop|notebook|probook|elitebook|latitude|inspiron|thinkpad|macbook/i.test(modelStr);
  if (isDesktop) return HERO_IMG_DESKTOP;
  if (isLaptop) return HERO_IMG_LAPTOP;
  return HERO_IMG_WORKSHOP;
}
export const DEFAULT_COUNTRY = 'France';

// Mode teaser pour les Deals Groupes : on garde la section visible
// (menu, page, illustrations) mais on désactive toute interaction
// commerciale tant que les conditions stock/prix ne sont pas réunies.
// Repasser à false pour réactiver la section sans autre modification.
export const DEALS_TEASER_MODE = true;
export const DEALS_TEASER_MESSAGE = "Cette section est en cours de construction. Les deals groupés arriveront bientôt — vous ne pouvez pas encore réserver.";

export const ROLE_LABELS = {
  client: 'Client',
  gestionnaire: 'Gestionnaire',
  admin_boutique: 'Admin boutique',
  superadmin: 'Superadmin',
};

export const CUSTOMER_TYPE_LABELS = {
  particulier: 'Particulier',
  professionnel: 'Professionnel',
};

export const BUSINESS = {
  name: 'Atelier Météris',
  tagline: 'Votre boutique informatique a Meaux',
  url: 'https://boutique.meteris.fr',
  // Règle de William du 22/10/2026 : 01 84 74 44 95 = atelier / grand public (la boutique « Atelier Météris ») ;
  // le standard METERIS est réservé aux clients SOUS CONTRAT. `telephoneRaw` sert aux liens tel: (format international).
  telephone: '01 84 74 44 95',
  telephoneRaw: '+33184744495',
  adresse: '8 Rue Georges Claude, 77100 Meaux',
  ville: 'Meaux',
  codePostal: '77100',
  horaires: {
    Lundi: 'Dépôt / Retrait : 16h30 - 18h00',
    Mardi: 'Dépôt / Retrait : 16h30 - 18h00',
    Mercredi: 'Dépôt / Retrait : 16h30 - 18h00',
    Jeudi: 'Dépôt / Retrait : 16h30 - 18h00',
    Vendredi: 'Dépôt / Retrait : 16h30 - 18h00',
    // Même lieu que l'atelier, « ouvert la plupart des samedis » : les dates vivent dans le portail, affichées sur la
    // page Horaires de l'atelier (revue Codex du 25/10/2026 : la boutique disait « Fermé »).
    Samedi: 'Ouvert la plupart des samedis',
    Dimanche: 'Fermé',
  },
  // Lien affiché à la suite d'un jour des horaires : « Samedi : ouvert la plupart des samedis — voir les dates ».
  horairesLiens: {
    Samedi: { texte: 'voir les dates', url: 'https://atelier.meteris.fr/horaires' },
  },
  creneauRetrait: '16h30 - 18h00',
  urlGoogleMaps: 'https://www.google.com/maps/place/Meteris+Informatique/@48.9586908,2.9154217,17z/data=!4m15!1m8!3m7!1s0x47e8a17dd3e2741b:0xa2b67f1dba019c7b!2s8+Rue+Georges+Claude,+77100+Meaux!3b1!8m2!3d48.9586908!4d2.9179966!16s%2Fg%2F11bw3y9rp9!3m5!1s0x47e8a3ce34ecae21:0x9451610aa2be2ba8!8m2!3d48.959257!4d2.9177148!16s%2Fg%2F1td4z52c?entry=ttu&g_ep=EgoyMDI2MDMwNC4xIKXMDSoASAFQAw%3D%3D',
  urlGBPAvis: 'https://g.page/meaux-informatique/review',
  siret: '531 527 869 00014',
  hebergeur: 'OVH SAS, 2 rue Kellermann, 59100 Roubaix',
  // Mentions légales — éditeur réel (« Atelier Météris » = enseigne de la société METERIS).
  // Données vérifiées via l'API officielle recherche-entreprises (2026-06-02).
  legal: {
    raisonSociale: 'METERIS',
    formeJuridique: 'SARL',
    capital: '5 000 €',
    rcs: 'RCS Meaux 531 527 869',
    siret: '531 527 869 00014',
    tva: 'FR37531527869',
    siege: '12 Allée des Tilleuls, 77100 Meaux',
    ape: "95.11Z (réparation d'ordinateurs et d'équipements périphériques)",
    directeurPublication: 'William Bernard',
  },
};

// RDV téléphonique « étude du besoin » (moteur it_bookings du portail, type
// etude_besoin). Lien profond : la page RDV de la vitrine pré-sélectionne le
// type et ouvre le calendrier. Gratuit, 10 min — CTA conseil avant-vente.
export const RDV_CONSEIL_URL = 'https://atelier.meteris.fr/rendez-vous?type=etude_besoin';

function getApiErrorMessage(payload, fallback = 'Erreur serveur') {
  if (!payload || typeof payload !== 'object') return fallback;
  if (payload.error && typeof payload.error === 'object' && payload.error.message) return payload.error.message;
  if (payload.detail && typeof payload.detail === 'object' && payload.detail.message) return payload.detail.message;
  if (typeof payload.detail === 'string' && payload.detail) return payload.detail;
  if (typeof payload.error === 'string' && payload.error) return payload.error;
  if (typeof payload.message === 'string' && payload.message) return payload.message;
  return fallback;
}

async function parseApiResponse(res, fallbackMessage = 'Erreur serveur') {
  if (res.status === 204) return null;

  const payload = await res.json().catch(() => null);

  if (!res.ok || payload?.success === false) {
    const error = new Error(getApiErrorMessage(payload, `${fallbackMessage} (${res.status})`));
    // Le corps de la réponse est ATTACHÉ à l'erreur, il ne remplace rien : tous
    // les appelants existants continuent de ne lire que `message` et gardent le
    // comportement qu'ils avaient. C'est la solution la moins invasive au fait
    // que certains refus portent un détail structuré qu'un message ne peut pas
    // transporter — le 409 `cart_invalid` de POST /api/orders/cart et son
    // `errors[]` ligne par ligne (cf. cartLineErrors). Sans cet attachement,
    // l'affichage des erreurs par ligne du panier serait impossible.
    error.status = res.status;
    error.payload = payload;
    throw error;
  }

  if (payload && typeof payload === 'object' && payload.success === true && 'data' in payload) {
    return payload.data;
  }

  return payload;
}

async function fetchAPI(endpoint, options = {}) {
  const url = `${API_URL}${endpoint}`;
  const shouldAuth =
    options.auth === true ||
    endpoint.startsWith('/api/admin') ||
    endpoint.startsWith('/api/auth') ||
    endpoint.startsWith('/api/account');

  const headers = { ...(options.headers || {}) };
  const isFormData = options.body instanceof FormData;

  if (!isFormData && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  if (shouldAuth) {
    const token = getStoredSessionToken();
    if (token) headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(url, { ...options, headers });
  return parseApiResponse(res);
}

export const getProducts = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return fetchAPI(`/api/products?${qs}`);
};

// Auth email + mot de passe (Vague 4) — en plus de Google SSO
export const authRegister = (data) =>
  fetchAPI('/api/auth/register', { method: 'POST', body: JSON.stringify(data) });

export const authLogin = (email, password) =>
  fetchAPI('/api/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) });

export const authForgotPassword = (email) =>
  fetchAPI('/api/auth/password/forgot', { method: 'POST', body: JSON.stringify({ email }) });

export const authResetPassword = (token, password) =>
  fetchAPI('/api/auth/password/reset', { method: 'POST', body: JSON.stringify({ token, password }) });

export const getProductFacets = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return fetchAPI(`/api/products/facets${qs ? `?${qs}` : ''}`);
};

export const getProduct = (id) => fetchAPI(`/api/products/${id}`);
export const getPublicSettings = () => fetchAPI('/api/settings/public');

// IDs ordonnés du catalogue filtré (navigation Suivant/Précédent des fiches).
export const getProductIds = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return fetchAPI(`/api/products/ids${qs ? `?${qs}` : ''}`);
};

// Auto-remplissage société par SIRET (inscription pro) — API officielle recherche-entreprises.
export const companyLookup = (siret) =>
  fetchAPI(`/api/company/lookup?siret=${encodeURIComponent(siret || '')}`);

export const getComingSoonStatus = () => fetchAPI('/api/feature/coming-soon');

export const subscribeToComingSoon = (data) =>
  fetchAPI('/api/coming-soon/subscribe', {
    method: 'POST',
    body: JSON.stringify(data),
  });

// Helper : retourne le texte de garantie à afficher selon le type de produit.
// Volontairement hardcodé en frontend (cf décision boss 2026-05-30) :
// - Neuf : 2 ans = garantie LÉGALE de conformité, due par le vendeur (METERIS) en B2C
//   — distincte de la garantie commerciale constructeur (souvent 12 mois). On affiche
//   la légale car c'est notre obligation et le meilleur argument client.
// - Reconditionné : la garantie légale de conformité est ELLE AUSSI de 2 ans (les CGV
//   du site le disent, article 9), et les 6 mois pièces et main-d'œuvre sont la
//   garantie COMMERCIALE METERIS, qui vient EN PLUS. N'afficher que les 6 mois
//   laissait croire au client du reconditionné que c'était sa seule protection.
//   ⚠️ Jamais de « 2 ans + 6 mois » : les deux protections sont CONCURRENTES, pas
//   consécutives, et l'addition (30 mois) nous serait opposable.
// La base produit garde son champ warranty libre pour les cas particuliers,
// mais l'affichage public utilise ces valeurs cohérentes.
export const getDisplayWarranty = (product) => {
  if (!product) return null;
  if (product.condition === 'neuf') return '2 ans (garantie légale)';
  if (product.condition === 'reconditionne') {
    return '6 mois pièces et main-d\'œuvre, en plus de la garantie légale de conformité de 2 ans';
  }
  return product.warranty || null;
};

// Libellés FR des vraies catégories produit (source unique). "pc" = anciens
// reconditionnés (compat). "accessoire" = options vendues avec un PC. Cf décision
// boss 2026-05-29 : afficher les vraies catégories, plus de fourre-tout accessoire.
export const CATEGORY_LABELS = {
  pc: 'PC',
  pc_fixe: 'PC fixe',
  portable: 'Portable',
  // Tablettes ajoutées à l'auto-publish portail le 2026-08-02 (57 fiches) :
  // sans ce libellé elles s'affichaient « Produit » et sans filtre dédié.
  tablette: 'Tablette',
  ecran: 'Écran',
  imprimante: 'Imprimante',
  serveur: 'Serveur',
  peripherique: 'Périphérique',
  stockage: 'Stockage',
  reseau: 'Réseau',
  logiciel: 'Logiciel',
  accessoire: 'Accessoire',
};

// Catégories proposées dans le filtre public (ordre d'affichage ; "accessoire"
// est masqué du catalogue public côté backend, donc absent ici).
// "pc" (ancien fourre-tout reconditionné) est RETIRÉ des filtres : depuis la migration
// 2026-05-30 les reconditionnés sont rangés dans leur vrai type (pc_fixe/portable).
// "pc" reste dans CATEGORY_LABELS comme alias de compat pour d'éventuels résidus.
export const PUBLIC_CATEGORY_FILTERS = [
  'pc_fixe', 'portable', 'tablette', 'ecran', 'imprimante', 'serveur',
  'peripherique', 'stockage', 'reseau', 'logiciel',
];

export const getCategoryLabel = (product) => {
  const cat = typeof product === 'string' ? product : product?.category;
  return CATEGORY_LABELS[cat] || 'Produit';
};

export const getComingSoonSubscribers = () =>
  fetchAPI('/api/admin/coming-soon/subscribers', { auth: true });

// Mise en avant (« Sélection METERIS ») — Vague 2 2026-05-30
export const getFeaturedProducts = (limit = 8) =>
  fetchAPI(`/api/products/featured?limit=${limit}`);

export const setProductFeatured = (productId, featured, label = null) =>
  fetchAPI(`/api/admin/products/${productId}/featured`, {
    method: 'POST',
    auth: true,
    body: JSON.stringify({ featured, label }),
  });

export const createReservation = (productId, data = {}) =>
  fetchAPI(`/api/reservations?product_id=${productId}`, {
    method: 'POST',
    auth: true,
    body: JSON.stringify(data),
  });

// ── Affichage d'un prix ────────────────────────────────────────────────
// Format français : séparateur de milliers, deux décimales, euro suffixé
// (« 1 000,00 € »). Toujours TTC, comme partout dans la boutique. Les fiches
// produit et les cartes catalogue gardent leur rendu typographique en deux
// niveaux (entier géant + centimes) : c'est un parti pris graphique, pas un
// second formateur — tout affichage de prix en une seule taille passe ici.
const PRICE_FORMATTER = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
export const formatPrice = (value) => {
  const amount = Number(value);
  return PRICE_FORMATTER.format(Number.isFinite(amount) ? amount : 0);
};

// ── Commande (produit hors stock) avec paiement en ligne ───────────────
// Nouveau modèle (validé) : vente à distance classique. Le client paie le
// PRIX TOTAL en ligne (plus d'acompte, plus de solde au comptoir). Le backend
// renvoie deposit_amount = prix total et balance_due = 0. computeDeposit garde
// son nom/signature pour ne pas casser les imports, mais renvoie désormais le
// montant total à régler en ligne.
export function computeDeposit(price) {
  if (!price || price <= 0) return 0;
  return Math.round(Number(price) * 100) / 100;
}

// Crée une commande spéciale (auth) — body invité {first_name,last_name,email,phone}
// ou {} si connecté. Réponse : {success, reservation_id, deposit_amount,
// balance_due, client_secret}. 503 deposit_unavailable si Stripe non configuré.
export const createSpecialOrder = (productId, data = {}) =>
  fetchAPI(`/api/reservations/special-order?product_id=${productId}`, {
    method: 'POST',
    auth: true,
    body: JSON.stringify(data),
  });

// ── Commande panier (multi-lignes) ─────────────────────────────────────
// N'envoie QUE des identifiants et des quantités : le serveur relit les prix en
// base. Réponse : {success, reservation_id, mode, total, deposit_amount,
// provider?, paypal_order_id?, approval_url?}. 409 cart_invalid + errors[] si une
// ligne n'est plus commandable.
// Les Garanties Atelier voyagent dans le MÊME tableau `items`, sous la forme
// `{kind, target_product_id, years}` attendue par `cart_svc.validate_cart` : le
// produit couvert et la durée, jamais de montant ni de libellé. Le serveur
// applique le barème au prix relu en base — un prix envoyé d'ici serait ignoré,
// et l'envoyer laisserait croire l'inverse.
export const createCartOrder = (items, data = {}, warranties = []) =>
  fetchAPI('/api/orders/cart', {
    method: 'POST',
    auth: true,
    body: JSON.stringify({
      items: [
        ...items.map(({ product_id, qty }) => ({ product_id, qty })),
        ...(warranties || []).map(({ target_product_id, years }) => ({
          kind: 'warranty', target_product_id, years,
        })),
      ],
      ...data,
    }),
  });

// Accessoires suggérés pour l'ENSEMBLE du panier (« Complétez votre commande »).
// N'envoie que les identifiants des lignes : le serveur applique la règle de la
// fiche produit (accessoires propres au produit, sinon défaut global), fusionne,
// dédoublonne et exclut ce qui est déjà au panier.
//
// ⚠️ Réponse : des produits SÉRIALISÉS, dont l'identifiant est `id` et les
// visuels `images[]`. Traduire avant d'appeler `addItem`, qui exige `product_id`
// et sort silencieusement sans lui.
export const getCartAddonSuggestions = (productIds) =>
  fetchAPI('/api/cart/addon-suggestions', {
    method: 'POST',
    body: JSON.stringify({ product_ids: productIds }),
  });

// Options de Garantie Atelier proposables pour les lignes du panier.
// Réponse : `{product_id: [{years, price, service_label}]}` — ici la clé EST bien
// `product_id`, ce ne sont pas des produits sérialisés. Un produit non éligible,
// retiré de la vente, ou dont le barème ne sait pas dire le montant est
// simplement absent : aucune option n'est alors proposée.
//
// `service_label` (« Main-d'œuvre incluse pendant 1 an ») vient du serveur et
// n'est JAMAIS reconstruit ici : son texte exact est une décision commerciale,
// pas une donnée qui se déduit d'un nombre d'années.
export const getCartWarrantyOptions = (productIds) =>
  fetchAPI('/api/cart/warranty-options', {
    method: 'POST',
    body: JSON.stringify({ product_ids: productIds }),
  });

// Détail ligne par ligne d'un refus 409 `cart_invalid` : [{product_id, code,
// message, max_qty?}]. Le contrat du serveur est décrit à un seul endroit, ici,
// pour que la page panier et le tunnel de commande le lisent de la même façon.
// Renvoie [] pour toute autre erreur (maintenance, réseau, 500…) : un appelant
// ne peut pas confondre « panier refusé » et « appel échoué ».
export const cartLineErrors = (error) => (
  error?.payload?.error?.code === 'cart_invalid' && Array.isArray(error.payload.errors)
    ? error.payload.errors
    : []
);

// Reprise de paiement via lien de relance (token opaque). Réponse DÉBALLÉE par
// `parseApiResponse` : {approval_url} — et non {data:{approval_url}}, contrairement à
// ce que ce commentaire affirmait, ce qui avait rendu `ResumeOrder` inopérante.
export const resumeOrderPayment = (token) =>
  fetchAPI('/api/reservations/resume-payment', {
    method: 'POST',
    body: JSON.stringify({ token }),
  });

// Capture le paiement PayPal après approbation de l'acheteur (renvoie .data
// déballé : {status:"captured", order_id}). Utilisé par SpecialOrderModal
// dans onApprove des PayPalButtons.
export const capturePaypalOrder = (orderId) =>
  fetchAPI(`/api/payments/paypal/capture/${orderId}`, { method: 'POST', auth: true });

export const createQuoteRequest = (data) =>
  fetchAPI('/api/quote-request', {
    method: 'POST',
    body: JSON.stringify(data),
  });

// Liste d'attente publique : "prévenez-moi quand un produit similaire arrive"
// Utilisé sur les fiches Réservé / Vendu, en remplacement du bouton Réserver.
export const joinProductWaitingList = (productId, data) =>
  fetchAPI(`/api/products/${productId}/waiting-list`, {
    method: 'POST',
    body: JSON.stringify(data),
  });

export const getGoogleAuthUrl = (redirectUri, intent) =>
  fetchAPI(`/api/auth/google-url?redirect_uri=${encodeURIComponent(redirectUri)}&intent=${intent}`);

export const exchangeGoogleCode = ({ code, redirectUri, intent }) =>
  fetchAPI('/api/auth/google-callback', {
    method: 'POST',
    body: JSON.stringify({ code, redirect_uri: redirectUri, intent }),
  });

export const getAuthMe = () => fetchAPI('/api/auth/me', { auth: true });

export const authLogout = async () => {
  try {
    await fetchAPI('/api/auth/logout', { method: 'POST', auth: true });
  } finally {
    clearStoredSessionToken();
  }
};

export const getAccountProfile = () => fetchAPI('/api/account/profile', { auth: true });

export const updateAccountProfile = (data) =>
  fetchAPI('/api/account/profile', {
    method: 'PUT',
    auth: true,
    body: JSON.stringify(data),
  });

export const getAccountDashboard = () => fetchAPI('/api/account/dashboard', { auth: true });
export const getAccountReservations = (limit = 10) => fetchAPI(`/api/account/reservations?limit=${limit}`, { auth: true });
export const getAccountOrders = (limit = 10) => fetchAPI(`/api/account/orders?limit=${limit}`, { auth: true });
export const getWishlist = () => fetchAPI('/api/account/wishlist', { auth: true });

export const addToWishlist = (productId) =>
  fetchAPI(`/api/account/wishlist/${productId}`, {
    method: 'POST',
    auth: true,
  });

export const removeFromWishlist = (productId) =>
  fetchAPI(`/api/account/wishlist/${productId}`, {
    method: 'DELETE',
    auth: true,
  });

export const getDashboard = () => fetchAPI('/api/admin/dashboard', { auth: true });
export const getMaintenanceSettings = () => fetchAPI('/api/admin/settings/maintenance', { auth: true });

export const updateMaintenanceSettings = (enabled) =>
  fetchAPI('/api/admin/settings/maintenance', {
    method: 'PUT',
    auth: true,
    body: JSON.stringify({ enabled }),
  });

// Barème de la Garantie Atelier — mêmes permissions que le réglage de
// maintenance ci-dessus (`maintenance:view` / `maintenance:update`).
export const getWarrantyTiersSettings = () => fetchAPI('/api/admin/settings/warranty-tiers', { auth: true });

export const updateWarrantyTiers = (tiers) =>
  fetchAPI('/api/admin/settings/warranty-tiers', {
    method: 'PUT',
    auth: true,
    body: JSON.stringify({ tiers }),
  });

export const searchIcecat = (searchType, value) =>
  fetchAPI(`/api/admin/products/icecat-search?search_type=${encodeURIComponent(searchType)}&value=${encodeURIComponent(value)}`, { auth: true });

export const searchExistingProducts = (q) =>
  fetchAPI(`/api/admin/products/search?q=${encodeURIComponent(q)}`, { auth: true });

export const getAdminProducts = (includeArchived = false) =>
  fetchAPI(`/api/admin/products?include_archived=${includeArchived}`, { auth: true });

export const createProduct = (data) =>
  fetchAPI('/api/admin/products', {
    method: 'POST',
    auth: true,
    body: JSON.stringify(data),
  });

export const updateProduct = (id, data) =>
  fetchAPI(`/api/admin/products/${id}`, {
    method: 'PUT',
    auth: true,
    body: JSON.stringify(data),
  });

export const deleteProduct = (id) =>
  fetchAPI(`/api/admin/products/${id}`, {
    method: 'DELETE',
    auth: true,
  });

export const bulkDeleteProducts = (productIds) =>
  fetchAPI('/api/admin/products/bulk-delete', {
    method: 'POST',
    auth: true,
    body: JSON.stringify({ product_ids: productIds }),
  });

export const bulkUpdateProducts = (productIds, field, value) =>
  fetchAPI('/api/admin/products/bulk-update', {
    method: 'PUT',
    auth: true,
    body: JSON.stringify({ product_ids: productIds, field, value }),
  });

export const uploadProductImage = async (productId, file) => {
  const formData = new FormData();
  formData.append('file', file);

  const headers = {};
  const token = getStoredSessionToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API_URL}/api/admin/products/${productId}/images`, {
    method: 'POST',
    headers,
    body: formData,
  });
  return parseApiResponse(res, 'Erreur upload');
};

export const deleteProductImage = (productId, filename) =>
  fetchAPI(`/api/admin/products/${productId}/images/${filename}`, {
    method: 'DELETE',
    auth: true,
  });

export const reorderProductImages = (productId, images) =>
  fetchAPI(`/api/admin/products/${productId}/images/reorder`, {
    method: 'PUT',
    auth: true,
    body: JSON.stringify(images),
  });

export const getAdminReservations = (status) => {
  const qs = status ? `?status=${status}` : '';
  return fetchAPI(`/api/admin/reservations${qs}`, { auth: true });
};

export const markReservationSold = (id) =>
  fetchAPI(`/api/admin/reservations/${id}/sold`, {
    method: 'PUT',
    auth: true,
  });

// Marque une réservation « prête à retirer » (produit arrivé) → démarre la fenêtre
// de retrait + envoie l'email « c'est prêt » au client.
export const markReservationReady = (id) =>
  fetchAPI(`/api/admin/reservations/${id}/ready`, {
    method: 'PUT',
    auth: true,
  });

// Transition rapide d'état commercial sans flow réservation client.
// status doit valoir 'available' | 'reserved' | 'sold'.
export const setProductSaleStatus = (productId, status) =>
  fetchAPI(`/api/admin/products/${productId}/sale-status`, {
    method: 'PUT',
    auth: true,
    body: JSON.stringify({ status }),
  });

export const cancelReservation = (id) =>
  fetchAPI(`/api/admin/reservations/${id}/cancel`, {
    method: 'PUT',
    auth: true,
  });

export const extendReservation = (id, hours = 24) =>
  fetchAPI(`/api/admin/reservations/${id}/extend?hours=${hours}`, {
    method: 'PUT',
    auth: true,
  });

export const getAdminOrders = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return fetchAPI(`/api/admin/orders${qs ? `?${qs}` : ''}`, { auth: true });
};

export const getAdminUsers = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return fetchAPI(`/api/admin/users${qs ? `?${qs}` : ''}`, { auth: true });
};

export const getAdminUser = (id) => fetchAPI(`/api/admin/users/${id}`, { auth: true });

export const updateAdminUser = (id, data) =>
  fetchAPI(`/api/admin/users/${id}`, {
    method: 'PUT',
    auth: true,
    body: JSON.stringify(data),
  });

export const seedData = () =>
  fetchAPI('/api/admin/seed', {
    method: 'POST',
    auth: true,
  });

export const getNotifications = () => fetchAPI('/api/admin/notifications', { auth: true });

export const markNotificationsRead = () =>
  fetchAPI('/api/admin/notifications/read', {
    method: 'PUT',
    auth: true,
  });

export const getImageUrl = (filename) => (filename ? `${API_URL}/api/uploads/${filename}` : null);

// Suppliers / Fournisseurs
export const getSuppliers = () => fetchAPI('/api/admin/suppliers', { auth: true });

export const createSupplier = (data) =>
  fetchAPI('/api/admin/suppliers', { method: 'POST', auth: true, body: JSON.stringify(data) });

export const updateSupplier = (id, data) =>
  fetchAPI(`/api/admin/suppliers/${id}`, { method: 'PUT', auth: true, body: JSON.stringify(data) });

export const deleteSupplier = (id) =>
  fetchAPI(`/api/admin/suppliers/${id}`, { method: 'DELETE', auth: true });

export const addSupplierPrice = (supplierId, data) =>
  fetchAPI(`/api/admin/suppliers/${supplierId}/prices`, { method: 'POST', auth: true, body: JSON.stringify(data) });

export const getPricesForProduct = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return fetchAPI(`/api/admin/suppliers/prices-for-product?${qs}`, { auth: true });
};

export const generateDescription = (data) =>
  fetchAPI('/api/admin/products/generate-description', {
    method: 'POST',
    body: JSON.stringify(data),
  });

export const suggestCleanName = (currentName) =>
  fetchAPI('/api/admin/products/suggest-name', {
    method: 'POST',
    body: JSON.stringify({ current_name: currentName }),
  });

// ── Deals ──────────────────────────────────────────────
export const getDeals = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return fetchAPI(`/api/deals?${qs}`);
};

export const getDeal = (id) => fetchAPI(`/api/deals/${id}`);

export const participateInDeal = (dealId, data) =>
  fetchAPI(`/api/deals/${dealId}/participate`, {
    method: 'POST',
    auth: true,
    body: JSON.stringify(data),
  });

export const getPaymentConfig = () => fetchAPI('/api/payments/config');

// Admin deals
export const getAdminDeals = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return fetchAPI(`/api/admin/deals?${qs}`, { auth: true });
};

export const createDeal = (data) =>
  fetchAPI('/api/admin/deals', { method: 'POST', auth: true, body: JSON.stringify(data) });

export const updateDeal = (id, data) =>
  fetchAPI(`/api/admin/deals/${id}`, { method: 'PUT', auth: true, body: JSON.stringify(data) });

export const validateDeal = (id) =>
  fetchAPI(`/api/admin/deals/${id}/validate`, { method: 'PUT', auth: true });

export const cancelDeal = (id) =>
  fetchAPI(`/api/admin/deals/${id}/cancel`, { method: 'PUT', auth: true });

export const extendDeal = (id, days = 7) =>
  fetchAPI(`/api/admin/deals/${id}/extend?days=${days}`, { method: 'PUT', auth: true });

export const getDealParticipations = (dealId) =>
  fetchAPI(`/api/admin/deals/${dealId}/participations`, { auth: true });
